export function success(data) {
  return {
    ok: true,
    ...(data || {}),
  };
}

export function failure(data) {
  return {
    ok: false,
    ...(data || {}),
  };
}



// WEBPACK FOOTER //
// ./src/actions/helpers.js